import { useState } from 'react';
import styles from './tooltip.module.css';

interface ITooltipProps {
  children: JSX.Element | JSX.Element[] | string;
  content: string;
  direction?: 'top' | 'bottom' | 'right' | 'left';
}

export const Tooltip = (props: ITooltipProps) => {
  let timeout: ReturnType<typeof setTimeout>;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, 300);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div className='relative inline-block' onMouseEnter={showTip} onMouseLeave={hideTip}>
      {props.children}
      {active && <div className={`${styles.toolTip} ${styles[props.direction || 'top']}`}>{props.content}</div>}
    </div>
  );
};
